export default {"src":"/_next/static/media/nlg.5a1d0f0d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};